function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 15,
  fill: "none",
  viewBox: "0 0 19 15",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 4h11v2H0zm0-2h11V0H0zm0 8h7V8H0zm15.01-3.13 1.41-1.41 2.12 2.12-1.41 1.41zm-.71.71L9 12.88V15h2.12l5.3-5.3z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-add-note.svg";
export { SvgComponent as ReactComponent };